/*
  全部页面引入
 */

import Base from "./Base";
import RoomNo from "./RoomNo";
import AccountItem from "./AccountItem";
import AccountType from "./AccountType";
import RoomStatusColor from "./RoomStatusColor.vue";
import RoomIcon from "./RoomIcon.vue";

const pages = {
  Base,
  RoomNo,
  AccountItem,
  AccountType,
  RoomStatusColor,
  RoomIcon
};
export default pages;
